export const LOAD_DOCS = 'LOAD_DOCS'
export const LOAD_CURRENT_FOLDER = 'LOAD_CURRENT_FOLDER'
export const ADD_DOCS_META = 'ADD_DOCS_META'
export const ADD_DOC = 'ADD_DOC'
export const UPDATE_DOC = 'UPDATE_DOC'
export const DELETE_DOC = 'UPDATE_DOC'
export const LOAD_DOC_ROLES = 'LOAD_DOC_ROLES'
